import React, { useState } from "react";
import { createPortal } from "react-dom";
import InsertCalculation from "./InsertCalculation";
import ModifyCalculation from "./ModifyCalculation";

function CalculationSettings({ purchaseOrderHeaderTarget = null }) {
  const [activeTab, setActiveTab] = useState("INSERT");

  return (
    <>
      {purchaseOrderHeaderTarget && createPortal(
        <div className="Form-Design-section-tabs">
          <div className="Form-Design-section-tabs-bar">
            <button
              type="button"
              className={`Form-Design-section-tabs-button ${activeTab === "INSERT" ? "active" : ""}`}
              onClick={() => setActiveTab("INSERT")}
            >
              Insert
            </button>

            <button
              type="button"
              className={`Form-Design-section-tabs-button mode-update ${activeTab === "MODIFY" ? "active" : ""}`}
              onClick={() => setActiveTab("MODIFY")}
            >
              Modify
            </button>
          </div>
        </div>,
        purchaseOrderHeaderTarget,
      )}

      {activeTab === "INSERT" ? (
        <InsertCalculation />
      ) : (
        <ModifyCalculation />
      )}
    </>
  );
}

export default CalculationSettings;
